import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('rehabToken') || localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Check if the error is an authentication error (401) or forbidden (403)
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      // But, we want to allow the login component to handle its own 401 errors
      if (error.config.url !== '/user/login') {
        localStorage.removeItem('rehabToken');
        localStorage.removeItem('token');
        // Reload the page to clear state and redirect to login for expired sessions
        window.location.reload();
      }
    }
    // For login errors or other types of errors, just pass them along
    return Promise.reject(error);
  }
);

export default api;